import { render, staticRenderFns } from "./TheHolidays.vue?vue&type=template&id=fc4a420c&scoped=true&"
import script from "./TheHolidays.vue?vue&type=script&lang=js&"
export * from "./TheHolidays.vue?vue&type=script&lang=js&"
import style0 from "./TheHolidays.vue?vue&type=style&index=0&id=fc4a420c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc4a420c",
  null
  
)

export default component.exports